const ENVIO_INVENTARIO = (state, envio_inventario) => {
    state.envio_inventario = envio_inventario;
};

export default {
    ENVIO_INVENTARIO,
};